export default {
    modelValue: {
        type: [Array, Number],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    autoClose: {
        type: Boolean,
        default: undefined
    },
    autoWidth: {
        type: Boolean,
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: String,
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    fixedGroupTemplate: {
        type: [String, Function],
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    groupTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    highlightFirst: {
        type: Boolean,
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    maxSelectedItems: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    itemTemplate: {
        type: [String, Function],
        default: undefined
    },
    tagTemplate: {
        type: [String, Function],
        default: undefined
    },
    tagMode: {
        type: String,
        default: undefined
    },
    value: {
        type: [Array, Number],
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },
    virtual: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    dataBound: {
        type: Function,
        default: undefined
    }, 
    filtering: Function,
    open: Function,
    select: Function,
    deselect: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiSelect/MultiSelectProps.js